import axiosInstance from "../service/AxiosInstance";

const useValuationWarning = (
  dealerData,
  selectedDealerId,
  newValuationName,
  Create_New_Valuation,
  setShowWarningModal,
  setWarningMessage,
  setWarning,
  setIsModalOpen,
  showOverlay,
  selectedDealerInfoId
) => {
  const getMessages = async (dealer_id, dealer_info_id) => {
    try {
      const { data } = await axiosInstance.get(`/get_overlay`, {
        params: {
          dealer_id,
          dealer_info_id,
        },
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  };
  const handleValuation = async (action) => {
    if (selectedDealerInfoId && selectedDealerId && newValuationName) {
      if (showOverlay) {
        const data = await getMessages(selectedDealerId, selectedDealerInfoId);
        if (data && Array.isArray(data) && data.length > 0) {
          const messages = data.join("\n");
          setShowWarningModal(true);
          setIsModalOpen(false);
          setWarningMessage(`${messages}`);
        } else {
          await Create_New_Valuation();
        }
      } else {
        await Create_New_Valuation();
      }
    } else if (selectedDealerId && newValuationName) {
      const dealer = dealerData.find(
        (item) => item.dealer_info_id === selectedDealerId
      );

      if (dealer) {
        if (showOverlay) {
          const data = await getMessages(
            dealer.dealer_id,
            dealer.dealer_info_id
          );
          if (data && Array.isArray(data) && data.length > 0) {
            const messages = data.join("\n");
            setShowWarningModal(true);
            setIsModalOpen(false);
            setWarningMessage(`${messages}`);
          } else {
            await Create_New_Valuation();
          }
        } else {
          await Create_New_Valuation();
        }
      }
    } else {
      setWarning(true);
    }
  };

  return {
    handleValuation,
  };
};

export default useValuationWarning;
